import clsx from "clsx";
import Tag from "ui-components/Tag";

const getFileLabel = (file: File) => {
  const size = file.size;
  return `${file.name} (${
    size > 1024 * 1024
      ? `${Math.round(size / (1024 * 1024))}MB`
      : `${Math.round(size / 1024)}KB`
  })`;
};

interface Props {
  file: File;
  onRemove: () => unknown;
}

const FileTag = ({ file, onRemove }: Props) => (
  <Tag
    key={file.name}
    bgColorClass={clsx("bg-primary-main", "text-primary-contrastText")}
  >
    <p className="text-sm font-normal my-1 mx-1 text-primary-contrastText">
      {getFileLabel(file)}{" "}
      <span className="cursor-pointer" onClick={onRemove}>
        X
      </span>
    </p>
  </Tag>
);

export default FileTag;
